import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import moresg from './modules/moresg'
import live from './modules/live'
import shopping from './modules/shopping'
import question from 'lingdongliang-module/lib/question'
Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
    mainUrl: state => process.env.VUE_APP_ZHIXIN_URL
  },
  modules: {
    user,
    // ldlUser,
    moresg,
    live,
    shopping,
    question: question
  }
})
